import { useEffect, useState } from 'react'

import DaysCountdown from './components/DaysCountdown'
import HoursCountdown from './components/HoursCountdown'
import type { CountdownStyleProps, RemainingTime } from './types'
import { getRemainingTimeUntilMsTimestamp } from './utils/countDownUtils'
import { textColorModifierWithPrimary } from './utils/styleUtils'

const defaultRemainingTime: RemainingTime = {
  seconds: '00',
  minutes: '00',
  hours: '00',
  days: '00',
}

interface Props extends CountdownStyleProps {
  countdownTimestampMs: number
  daysFromInput: number
  className?: string
}

const Countdown = ({
  countdownTimestampMs,
  daysFromInput,
  clockBackGround,
  clockBackGroundHex,
  labelColorModifier,
  clockColorModifier,
  className,
}: Props) => {
  const [remainingTime, setRemainingTime] = useState(defaultRemainingTime)
  const updateRemainingTime = (countdown: number, daysFromInput: number) => {
    setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown, daysFromInput))
  }
  useEffect(() => {
    const intervalId = setInterval(() => {
      updateRemainingTime(countdownTimestampMs, daysFromInput)
    }, 1000)
    return () => clearInterval(intervalId)
  }, [countdownTimestampMs, daysFromInput])

  const parsedDays = parseInt(remainingTime.days, 10)

  const labelColor = textColorModifierWithPrimary(labelColorModifier)
  const clockColor = textColorModifierWithPrimary(clockColorModifier)

  const CountDown = parsedDays ? DaysCountdown : HoursCountdown
  return (
    <CountDown
      remainingTime={remainingTime}
      clockColor={clockColor}
      labelColor={labelColor}
      clockBackGround={clockBackGround}
      clockBackGroundHex={clockBackGroundHex}
      className={className}
    />
  )
}

export default Countdown
